<app-dashboard *ngIf="authUser.role.is_staff"></app-dashboard>
<app-affiliate-case-list *ngIf="!authUser.role.is_staff && authUser.role.name === 'Affiliate'">
</app-affiliate-case-list>
